import React from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import { Icon, message, Modal } from '@/components';
import { RootStore, chat, transcribe } from '@/models';
import ActionBtn from '../ActionBtn';
import styles from './index.less';
import classNames from 'classnames';
import HandupCount from '../../../HandupCount';
import { ShareScreenFull } from '@/models/meeting';

interface Props extends Partial<Pick<RootStore, 'rtc' | 'user' | 'meeting'>> {
  RTCInstance?: RootStore['rtc'];
  user?: RootStore['user'];
  meeting?: RootStore['meeting'];
}
const Member: React.FC<Props> = inject(({ store }) => {
  return {
    RTCInstance: store.rtc,
    user: store.user,
    meeting: store.meeting,
  };
})(
  observer((props) => {
    const { RTCInstance, user, meeting } = props;
    const { formatMessage } = useIntl();

    const openMember = () => {
      if (RTCInstance?.breakLineReconnecting) {
        return;
      }
      if (!meeting?.peoplePanelShow && meeting?.shareScreenFull === ShareScreenFull.FULL) {
        meeting?.setShareScreenFull(ShareScreenFull.EXIT_FULL);
      }
      // if (meeting?.peoplePanelShow && meeting?.shareScreenFull === ShareScreenFull.EXIT_FULL) {
      //   meeting?.setShareScreenFull(ShareScreenFull.FULL);
      // }
      meeting?.setPeoplePanelShow(!meeting?.peoplePanelShow, true);
      chat?.setChatVisible(false);
      transcribe?.setTranscribeVisible(false);
    };

    return (
      <>
        <ActionBtn
          title={formatMessage({ id: 'member' })}
          className={classNames(styles.memberBtn)}
          onClick={openMember}
        >
          <span onClick={(e) => e.stopPropagation()}>
            <HandupCount></HandupCount>
          </span>
          <Icon className={styles.icon} name="icon-contact" mode="symbol" size="24" />
        </ActionBtn>
      </>
    );
  })
);

export default Member;
